import React, { useEffect, useRef, useState } from "react"
import { Button, Col, Container, messageCard, Row } from "reactstrap"
import "./FeedbackStyle.css"
import { useDispatch } from "react-redux"
import {
  openFeedbackchats,
  sendFeedbackMsg,
  getFeedbackReset,
} from "store/actions"
import { useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import moment from "moment"
import Spinners from "components/Common/Spinner"

const ChatWindow = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const lastMessageRef = useRef(null)
  const [newMessage, setNewMessage] = useState("")
  const { conversationID, chatSubject, from_id, feedbackType, msg_to, from_name, student_name, staff_name, div_name } = location.state

  const { Loading, messageList, errors, sendMessageStatus } = useSelector(
    state => state.FeedBackReducer
  )

  const dates = new Set();

  const renderDate = (dateNum) => {
    if (dates.has(moment.utc(dateNum).format("DD/MM/YYYY"))) return null; // Prevent duplicates

    dates.add(moment.utc(dateNum).format("DD/MM/YYYY")); // Store date in UTC format

    const returnDate = (timestamp) => {

      return moment.utc(timestamp).format("DD/MM/YYYY"); // Ensure no timezone shift

    };

    return (
      <div className="my-2 d-flex justify-content-center align-items-center" style={{ fontSize: "10px" }}>
        <div className="p-2 mb-1 bg-white d-inline-block border rounded-4 shadow">
          {returnDate(dateNum)}
        </div>
      </div>
    );
  };


  const [isKeyboardVisible, setKeyboardVisible] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight
      const initialHeight = window.screen.height

      // If the difference is significant, assume the keyboard is visible
      const keyboardThreshold = 100 // Adjust as needed
      setKeyboardVisible(initialHeight - windowHeight > keyboardThreshold)
    }

    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    if (sendMessageStatus === 1) {
      setNewMessage("")
    }
  }, [sendMessageStatus])

  const handleSendMessage = () => {
    if (newMessage && newMessage !== "") {
      dispatch(
        sendFeedbackMsg({
          conversation_id: conversationID,
          message: newMessage,
          //  "device_name":"Device name (optional)"
        })
      )
      // dispatch(
      //   openFeedbackchats({
      //     conversation_id: conversationID,
      //     from_id,
      //     feedbackType
      //   })
      // )
    }
  }

  useEffect(() => {
    dispatch(getFeedbackReset())
    dispatch(
      openFeedbackchats({
        conversation_id: conversationID,
        from_id,
        feedbackType
      })
    )
  }, [conversationID])

  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ block: "end" })
    }
  }, [messageList, isKeyboardVisible])


  function updateTime(inputDate) {
    const isUTC = typeof inputDate === "string" && inputDate.endsWith("Z");
    const date = new Date(inputDate);

    if (isUTC) {

      let hours = date.getUTCHours()
      let minutes = date.getUTCMinutes()

      const ampm = hours >= 12 ? "pm" : "am"

      hours = hours % 12
      hours = hours ? hours : 12
      minutes = minutes

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")} ${ampm}`
    } else {
      let hours = date.getHours();
      let minutes = date.getMinutes();

      const ampm = hours >= 12 ? "pm" : "am"

      hours = hours % 12
      hours = hours ? hours : 12
      minutes = minutes


      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")} ${ampm}`

    }



  }


  const getSenderName = () => {
    const group_id = localStorage.getItem('group_id');
    const normalizedGroupId = group_id != null ? String(group_id) : null;

    switch (normalizedGroupId) {
      case '2':
        return msg_to;
      case '9':
         return <>{from_name} - {div_name}</>;
      case '10':
        if (feedbackType == 'Parents to Admin') {
          return <>{from_name} - {div_name}</>;
        } else {
          return <>{student_name} - {div_name} <b>TO</b> {staff_name}</>;
        }
      default:
        return 'not found';
    }
  };


  return (
    <div
      className={`chat-window ${!isKeyboardVisible ? "chatMain" : "fullwidth"
        } `}
    >
      <div className="messageCard">
        <header className="messageCard-header">
          <p className="messageCard-header-title mb-0 fw-bold">
            <i className="fas fa-circle is-online"></i>
            {chatSubject ? chatSubject : ""}
          </p>
          <p className="ps-3 text-secondary pt-0 m-0 text-nowrap">
            {
              getSenderName()
            }
          </p>
        </header>
        {/* <div className="messageCard-content chat-content"></div> */}
        {Loading ? (
          <Spinners />
        ) : (
          <div className="messageCard-content chat-content">

            {messageList &&

              messageList.length > 0 &&

              messageList.map((msg, index) => {

                return (

                  <div key={index}>

                    {renderDate(msg.createdDate)}
                    <div
                      className={`chat-message-group d-flex ${msg.direction === "out" ? "justify-content-end" : 'justify-content-start'}`}
                      key={index}
                    >
                      <div className={`chat-messages ${msg.direction === "out" ? "sent-wrapper" : "received-wrapper"}`}>
                        <div className={`message ${msg.direction === "out" ? "sent-msg" : 'received-msg'}`}>{msg.message}</div>
                        <div className="from">
                          {updateTime(msg.createdDate)}
                        </div>
                      </div>
                    </div>

                  </div>
                )
              })}

            <div className="">
              <div
                className=""
                // style={{ height: "5px" }}
                ref={lastMessageRef}
              />
            </div>
          </div>
        )}
      </div>

      {feedbackType !== 'Parents to Teachers' &&
        <div className="messageCard-footer w-100" id="chatBox-textbox">
          <textarea
            id="chatTextarea"
            className="chat-textarea fs-5"
            placeholder="Type Message..."
            value={newMessage}
            onChange={e => setNewMessage(e.target.value)}
          ></textarea>

          <div className="sendButton d-flex align-items-center justify-content-right">
            {newMessage !== "" ? (
              <i
                className="bx bx-send btn btn-primary btn-rounded ms-1"
                onClick={handleSendMessage}
              ></i>
            ) : null}
          </div>
        </div>
      }
    </div>
  )
}

export default ChatWindow
